import React from 'react';
import {
  WavesContainerStyled,
  LayerOneStyled,
  LayerTwoStyled,
  LayerThreeStyled,
} from './styles/HeaderSceneStyled';

import {
  LayerOne,
  LayerTwo,
  LayerThree,
} from '../../../images/layouts/detalle-otras-lineas';

const HeaderScene = () => (
  <WavesContainerStyled id="header-scene">
    <LayerOneStyled>
      <LayerOne />
    </LayerOneStyled>
    <LayerTwoStyled>
      <LayerTwo />
    </LayerTwoStyled>
    <LayerThreeStyled>
      <LayerThree />
    </LayerThreeStyled>
  </WavesContainerStyled>
);
export default HeaderScene;
